import React, {MouseEventHandler} from "react";
import {GenericComponentModel} from "../../../api/types/generic";
import {useRecoilState} from "recoil";
import {useTranslation} from "react-i18next";
import SearchFilters from "../../../common/components/SearchFilters";
import {rentalPeriodFiltersAtom, unitsEnumAtom,} from "../../../state/rentalPeriodsRecoil";

const RentalPeriodFilters = ({
                                 handleClickSearch,
                                 handleClickResetSearch,
                             }: {
    handleClickSearch: MouseEventHandler<HTMLButtonElement>;
    handleClickResetSearch: MouseEventHandler<HTMLButtonElement>;
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Recoil
    const [rentalPeriodFilters, setRentalPeriodFilters] = useRecoilState(
        rentalPeriodFiltersAtom
    );
    const [unitsEnum] = useRecoilState(unitsEnumAtom);

    const filtersOutOfCollapse: GenericComponentModel[] = [
        {
            name: "name",
            value: rentalPeriodFilters.name as string,
            label: `${t("pricing:rentalPeriods.form.labels.name")}`,
            handleChange: (value: string) =>
                setRentalPeriodFilters({...rentalPeriodFilters, name: value}),
            options: [],
            type: "TextField",
        },
        {
            name: "tpUnit",
            value: rentalPeriodFilters.tpUnit as string,
            label: `${t("pricing:rentalPeriods.form.labels.unit")}`,
            handleChange: (value: string) =>
                setRentalPeriodFilters({
                    ...rentalPeriodFilters,
                    tpUnit: value,
                }),
            options: unitsEnum,
            type: "Autocomplete",
        },
    ];
    const filtersInCollapse: GenericComponentModel[] = [];

    return (
        <SearchFilters
            filtersOutOfCollapse={filtersOutOfCollapse}
            filtersInCollapse={filtersInCollapse}
            handleClickSearch={handleClickSearch}
            handleClickResetSearch={handleClickResetSearch}
        />
    );
};

export default RentalPeriodFilters;
